import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaDotCircle } from "react-icons/fa";
import ContactUs from "../buttons/ContactUs";

const WhyChooseUs = () => {
  let [choose, setChoose] = useState(true);
  let [principles, setPrinciples] = useState(false);
  let [achievements, setAchievements] = useState(false);
  const handleChoose = (e) => {
    e.preventDefault();
    setPrinciples(false);
    setAchievements(false);
    setChoose(true);
  };
  const handlePrinciples = (e) => {
    e.preventDefault();
    setChoose(false);
    setAchievements(false);
    setPrinciples(true);
  };
  const handleAchievements = (e) => {
    e.preventDefault();
    setChoose(false);
    setPrinciples(false);
    setAchievements(true);
  };
  return (
    <div className="max-w-screen-2xl mx-auto py-6 lgl:py-28 borer-b-[1px] border-b border-b-primeColor flex flex-col lgl:flex-row gap-6 lgl:gap-0 xl:gap-10 px-4">
      <div className="w-full lgl:w-1/2 flex flex-col gap-6 lgl:gap-12">
        <h3 className="font-titleFont text-xl text-gray-600">
          Welcome to Educare English Learning Academy
        </h3>
        <h1 className="font-titleFont text-3xl md:text-5xl tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-primeColor to-darkPink font-bold flex flex-col gap-1">
          "Learn Naturally"
          <span className="translate-x-0 md:translate-x-32 lgl:translate-x-0 xl:translate-x-32 font-titleFont text-3xl md:text-5xl tracking-wide text-transparent bg-clip-text bg-gradient-to-r from-darkPink to-primeColor font-bold">
            {" "}
            "Speak Naturally"
          </span>
        </h1>
        <Link to="/contactus">
          <div>
            <ContactUs />
          </div>
        </Link>
      </div>
      <div className="w-full lgl:w-1/2 flex flex-col gap-4 md:gap-8 lgl:gap-12">
        <div className="w-full flex justify-between">
          <button
            onClick={handleChoose}
            className={`font-titleFont text-[14px] md:text-xl ${
              choose ? "text-primeColor" : "text-gray-400"
            } border-gray-400 border-l-[1px] border-r-[1px] px-1 md:px-6 lgl:px-2 xl:px-6 cursor-pointer font-semibold`}
          >
            Why Choose us
          </button>
          <button
            onClick={handlePrinciples}
            className={`font-titleFont text-[14px] md:text-xl ${
              principles ? "text-primeColor" : "text-gray-400"
            } border-gray-400 border-l-[1px] border-r-[1px] px-1 md:px-6 lgl:px-2 xl:px-6 cursor-pointer font-semibold`}
          >
            Our principles
          </button>
          <button
            onClick={handleAchievements}
            className={`font-titleFont text-[14px] md:text-xl ${
              achievements ? "text-primeColor" : "text-gray-400"
            } border-gray-400 border-l-[1px] border-r-[1px] px-1 md:px-6 lgl:px-2 xl:px-6 cursor-pointer font-semibold`}
          >
            Achievements
          </button>
        </div>
        <div className="flex flex-col gap-3">
          {choose && (
            <div>
              <ul className="font-bodyFont text-[14px] flex flex-col gap-1 text-gray-700">
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.2,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Our class is led by a highly qualified and experienced
                  instructor with over 10 years of teaching experience.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.4,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  We provide personalized attention and support to help every
                  student succeed.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.6,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Our English language club offers live classes and debates to
                  help students become fluent in English, while also fostering a
                  vibrant community of language enthusiasts.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.8,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  We offer special class notes to complement our regular
                  materials, providing students with key concepts, common
                  mistakes, and tips for success to enhance their learning
                  experience.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 1,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  We offer extra classes such as conversational practice,
                  writing workshops, and grammar clinics to help students deepen
                  their understanding, build their confidence, and excel in
                  learning a new language.
                </motion.li>

                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 1,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Our demo viva sessions help students prepare for their
                  language exams by providing practice opportunities, feedback,
                  and exam format familiarity from our experienced instructors.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 1,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  We offer presentation workshops to help students prepare for
                  delivering presentations in a new language. Our instructors
                  provide personalized feedback and cover everything from
                  preparation and delivery to handling questions and feedback,
                  helping students build confidence and overcome nerves.
                </motion.li>
              </ul>
            </div>
          )}
          {principles && (
            <>
              <motion.p
                initial={{ x: 100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{
                  delay: 0.2,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 1 },
                  ease: "easeIn",
                  duration: 1,
                }}
                className="font-bodyFont text-[14px] md:text-[16px] text-gray-600 tracking-wide leading-normal"
              >
                At EduCare English Learning Academy, we believe in the power of
                collaboration between our teachers and students, which has
                resulted in excellent outcomes for both parties. We are
                committed to maintaining consistency and ensuring that our
                syllabus meets global standards of quality. Our primary
                objective is to deliver authentic educational methods, which
                help our students make significant progress toward achieving
                their goals. Our students' remarkable achievements reflect our
                sincerity and dedication to their success.
              </motion.p>
            </>
          )}
          {achievements && (
            <div>
              <ul className="font-bodyFont text-[14px] flex flex-col gap-1 text-gray-700">
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.2,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Over 25 courses successfully launched and ongoing.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.35,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  More than 500 students enrolled in mainstream programs.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.5,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Over 100+ of students achieved success in the MOCK and central
                  exams.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.65,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Innovative approach to learning management in the regular
                  curriculum.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.65,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Job opportunities through English and Microsoft Office skills
                  training.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.65,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Developing presentation skills for employability and career
                  growth.
                </motion.li>
                <motion.li
                  initial={{ x: 50, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    delay: 0.65,
                    x: { type: "spring", stiffness: 60 },
                    opacity: { duration: 1 },
                    ease: "easeIn",
                    duration: 1,
                  }}
                  className="courseModuleListli text-base"
                >
                  <span className="courseModuleListliSpan text-base">
                    <FaDotCircle />
                  </span>
                  Practical learning methods and real-world projects to enhance
                  job readiness.
                </motion.li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
